import {EnrollAttestat} from './edu-info/enroll-attestat';
import {EnrollDiplomInfo} from './edu-info/enroll-diplom-info';
import {EnrollEntranceExamsInfo} from './edu-info/enroll-entrance-exams-info';
import {EnrollEntKtSerificateInfo} from './edu-info/enroll-ent-kt-serificate-info';
import {EnrollInterviewInfo} from './edu-info/enroll-interview-info';

export class EnrollEduInfo {
  edu_institute_graduate: number = null;
  edu_institute_country: number = null;
  edu_institute_place: number = null;
  edu_institute_localty: any = {};
  institutionId: number = null;
  edu_org_name: any = null;
  edu_doc_name = '';
  edu_doc_give_date: Date;
  edu_doc_scan: any;
  edu_received: number = null;
  type_of_admission = 2;
  edu_graduate_domestic: number = null;
  edu_graduate_domestic_operating_univ: number = null;
  edu_graduate_domestic_univ_name: any = null;
  edu_graduate_domestic_univ_spec: any = null;
  edu_graduate_domestic_univ_gpa: any = null;
  edu_graduate_foreign_name = '';
  edu_graduate_foreign_spec = '';
  edu_graduate_foreign_gpa = '0';
  edu_graduate_foreign_nostrif_number = '';
  edu_graduate_foreign_nostrif_date: Date;
  attestat: EnrollAttestat = new EnrollAttestat();
  diplom_info: EnrollDiplomInfo = new EnrollDiplomInfo();
  entrance_exams_info: EnrollEntranceExamsInfo = new EnrollEntranceExamsInfo();
  ent_kt_serificate_info: EnrollEntKtSerificateInfo = new EnrollEntKtSerificateInfo();
  interview_info: EnrollInterviewInfo = new EnrollInterviewInfo();
  additional_info = '';
  finishedCorrectionalSchool: boolean;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-edu-info.ts